import { gql } from '@apollo/client';

// Spread into the two tariff list queries only, not the shared PricingTariffFields: if the web
// deploys ahead of the tariff_categorization migration, only those two lists break.
export const TARIFF_CATEGORIZATION_FIELDS = gql`
    fragment TariffCategorizationFields on pricing_tariffs {
        tariff_id
        category
        commodity_tags
    }
`;

export const UPDATE_TARIFF_CATEGORIZATION = gql`
    ${TARIFF_CATEGORIZATION_FIELDS}

    mutation UpdateTariffCategorization($tariff_id: uuid!, $update: pricing_tariffs_set_input!) {
        tariff: update_pricing_tariffs_by_pk(pk_columns: { tariff_id: $tariff_id }, _set: $update) {
            ...TariffCategorizationFields
        }
    }
`;

// The accounts a tariff is assigned to: the client on each of its enabled pricing overrides.
// algo_type identifies the platform-wide defaults, which have no client.
export const TARIFF_ASSIGNMENTS = gql`
    query TariffAssignments($tariff_id: uuid!) {
        assignments: pricing_overrides(
            where: { _and: [{ tariff_id: { _eq: $tariff_id } }, { enabled: { _eq: true } }] }
        ) {
            pricing_override_id
            client_id
            algo_type
            client {
                client_id
                business_name
                user {
                    user_id
                    roles
                }
            }
        }
    }
`;
